/**
 * Explain: 项目中axios通用方法
 * */
import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'

const cancelTokens = []
const cancelTokenOuttime = 1000 * 60 * 2
setInterval(() => {
	let i = 0
	const nowTimeStamp = new Date().getTime()
	// console.log('delete cancelTokens:' + nowTimeStamp)
	for (const cancelToken of cancelTokens) {
		if (nowTimeStamp - cancelToken.timeStamp > cancelTokenOuttime) {
			cancelTokens.length = i
			break
		}
		i++
	}
}, cancelTokenOuttime)
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求中携带token
 * */
axios.interceptors.request.use(config => {
	// 登录流程控制中，根据本地是否存在token判断当前用户的登录情况；
	// 但是即使token存在，但也可能token是过期的，所以在每次的请求headers中携带token；
	// 后台根据携带的token判断用户的登录情况，并返回相应的状态码；
	// 而后可以在返回拦截器里，可以根据后台返回的状态码做统一的操作。
	const data = config.data || {}
	if (data.cancelTokenId) {
		config.cancelToken = new axios.CancelToken(function(cancel) {
			cancelTokens.unshift({
				id: data.cancelTokenId,
				cancel: cancel,
				timeStamp: new Date().getTime()
			})
		})
	}
	delete data.cancelTokenId

	if (config.method.toLowerCase() === 'post') {
		if (config.type === 'json') {
			config.headers['Content-Type'] = 'application/json;charset=UTF-8'
			config.data = JSON.stringify(config.data)
		} else if (config.type === 'formData') {
			console.log('=================', config.data)
		} else {
			config.data = qs.stringify(config.data)
		}
	}

	return config
})
// 返回拦截处理
axios.interceptors.response.use(
	response => {
		if (response.data && response.status === 200) {
			return response
		}
		if (response.status !== 200) {
			console.log('系统异常!')
		}
		return response
	},
	error => {
		console.log(error)
		return Promise.reject(error)
	}
)

// Explain:项目中接口请求，根据downFile字段来判断是下载文件的请求
export default async (options = { method: 'GET' }) => {
	const isData = true
	let downFile = false
	if (
		options.method.toUpperCase() !== 'POST' &&
		options.method.toUpperCase() !== 'DELETE' &&
		options.downFile
	) {
		// isData = false
		downFile = true
	}
	try {
		const response = await axios({
			method: options.method,
			url: options.url,
			data: isData ? options.data : null,
			params: options.method.toUpperCase() === 'POST' ? null : isData ? options.data : null,
			responseType: downFile ? 'blob' : 'json',
			type: options.type,
			transformRequest: [
				function() {
					if (options.data !== null) {
						return JSON.stringify(options.data)
					} else {
						return ''
					}
				}
			],
			headers: {
				'Content-Type': 'application/json;charset=UTF-8'
			}
		})
		if (downFile) {
			return response
		}
		if (response.status >= 200 && response.status < 300) {
			return response.data
		}
		return true
	} catch (e) {
		console.log(e)
		const vue = new Vue()
		// vue.$notify({ type: "danger", message: "系统错误" });
		throw new Error(e) // 断网等情况抛出错误
		return {
			status: 0,
			data: null
		}
	}
}

export const uploadFile = async (options = {}) => {
	try {
		const response = await axios({
			method: 'POST',
			url: options.url,
			data: options.data,
			responseType: 'json',
			type: 'formData',
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
		if (response.status >= 200 && response.status < 300) {
			return response.data
		}
		return true
	} catch (e) {
		console.log(e)
		throw new Error(e) // 断网等情况抛出错误
	}
}

export const cancelAxios = cancelTokenId => {
	if (!cancelTokenId) return
	let i = 0
	for (const cancelToken of cancelTokens) {
		if (cancelToken.id === cancelTokenId) {
			cancelToken.cancel()
			cancelTokens.splice(i, 1)
		}
		i++
	}
}
